
import { Options, Vue } from "vue-class-component";
import { store } from "@/store";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import Paging from "@/components/Paging.vue";
import {
  dispatchCreateSceneScript,
  dispatchDeleteScript,
  dispatchGetScripts,
  dispatchUpdateScript,
  dispatchGetScriptsContent,
} from "@/store/task/actions";
import { readScriptList } from "@/store/task/getters";
import {
  dispatchCreateProjectScenes,
  dispatchGetProjectScenes,
  dispatchUpdateProjectScene,
} from "@/store/project/actions";
import { readMyProjects, readProjectScenes } from "@/store/project/getters";
import {
  alert_re_chinese,
  getLocalProject,
  regChineseObJ,
  regEnglishObj,
  unique_json,
  downFile,
} from "@/utils";
import { readUserProfile } from "@/store/main/getters";
import { readPerformanceSelectOptions } from "@/store/performance/getters";
import { dispatchGetPerformanceSelectOptions } from "@/store/performance/actions";
import { ElMessage } from "element-plus";
import { IProjectScene } from "@/interfaces";

@Options({
  components: {
    SideMenu,
    Paging,
  },
})
export default class AccountManage extends Vue {
  onSizeChange(size) {
    this.onPaging(1, size)
  }

  public async downloadFile(row) {
    await dispatchGetScriptsContent(store, {
      script_id: row.script_id,
      project: this.project,
    }).then((res) => {
      if (res.script_content) {
        downFile(res.script_content, 'script.txt')
      } else {
        ElMessage.error("无对应的脚本");
      }
    });
  }
  // 自定义表单校验规则: 英文校验
  public re_english = (rule: any, value: any, callback: any) => {
    if (!regEnglishObj.test(value)) {
      callback(
        new Error(
          "游戏场景id只支持英文、数字、下划线、英文冒号、英文句号及横线"
        )
      );
    } else {
      callback();
    }
  };

  // 自定义element ui表单校验规则
  public validateChinese = (rule: any, value: any, callback: any) => {
    // 校验场景名称是否已存在
    let iscall = false;
    this.getProjectScenes.forEach((item: any) => {
      if (item.chinese === value) {
        iscall = true;
      }
    });
    // 如果游戏场景id存在将使用该游戏场景的场景名称,如果不存在则创建一个新的游戏场景, 并给予提示
    let is_original_scene_id = false;
    this.getProjectScenes.forEach((item: any) => {
      if (item.original_scene_id === this.addForm.original_scene_id) {
        is_original_scene_id = true;
      }
    });
    if (
      !is_original_scene_id &&
      value === "" &&
      this.addForm.original_scene_id !== ""
    ) {
      callback(new Error("场景id不存在，将为您创建一条新纪录, 请输入场景名称"));
    }
    if (iscall === false) {
      callback();
    } else {
      callback(new Error("场景名称已存在"));
    }
  };

  // 自定义表单校验规则: 中英文校验
  public re_chinese = (rule: any, value: any, callback: any) => {
    if (!regChineseObJ.test(value) && value !== "") {
      callback(
        new Error(
          "场景名称只支持中英文、数字、下划线、英文冒号、英文句号及横线"
        )
      );
    } else {
      callback();
    }
  };
  // 规则
  public addRules = {
    original_scene_id: [
      { required: true, message: "请输入游戏场景id", trigger: "blur" },
      { validator: this.re_english, trigger: "blur" },
    ],
    chinese: [
      { validator: this.validateChinese, trigger: "blur" },
      { validator: this.re_chinese, trigger: "blur" },
    ],
    script_id: [{ required: true, message: "请选择脚本", trigger: "change" }],
  };
  public scriptForm = {
    script_name: "",
    scene_chinese: "",
  };
  // 新增场景脚本表单
  public addForm = {
    script_id: "",
    original_scene_id: "",
    chinese: "",
  };

  public currentPage1 = 1;
  public record = 16; //记录条数
  public totalNum = this.getVisitStatistics.count; //分页总数
  public filterScript = "";
  public search = "";
  public search1 = "";
  public loading = false;
  public isAddScript = false;
  public dialogAddFormVisible = false;
  public addScript = false;
  public paramFile = "";
  public project = Number(getLocalProject());
  // 新增场景脚本
  public addScriptForm = {
    original_scene_id: "",
    chinese: "",
  };
  public async mounted() {
    this.loading = true;
    await dispatchGetProjectScenes(store, { project: this.project });
    await dispatchGetScripts(store, {
      project: this.project,
      page: this.currentPage1,
      size: this.record,
      script_name: this.search1,
    });
    await this.onPaging(this.record, 1);
    await dispatchGetPerformanceSelectOptions(store, {
      project: this.project,
    });
    this.loading = false;
  }

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.project
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  public upload = "";
  // 判断original_scene_id是否存在, 如果存在, 使用该场景的场景名称, 并禁用该场景名表单
  public handleAddScriptV2() {
    this.dialogAddFormVisible = true;
    this.filterScript = "";
  }

  public get chinese_disable() {
    let is_original_scene_id = false;
    this.getProjectScenes.forEach((item: any) => {
      if (item.original_scene_id === this.addForm.original_scene_id) {
        is_original_scene_id = true;
      }
    });
    if (is_original_scene_id) {
      this.addForm.chinese = "";
      return true;
    } else {
      return false;
    }
  }

  // 获得记录数据
  public get getVisitStatistics() {
    return readScriptList(store);
  }

  // 分页
  public async onPaging(page: any, size: any) {
    this.loading = true;
    this.record = page;
    this.currentPage1 = size;
    this.totalNum = this.getVisitStatistics.count;
    await dispatchGetScripts(store, {
      project: this.project,
      page: this.currentPage1,
      script_name: this.search1,
      size: this.record,
    });
    this.loading = false;
  }

  // 查询
  public async onSearch() {
    this.loading = true;
    await dispatchGetScripts(store, {
      project: this.project,
      page: 1,
      script_name: this.search1,
      size: this.record,
    });
    await this.onPaging(this.record, 1);
    this.loading = false;
  }

  // 按钮内容切换
  handleEdit(row: any, scriptForm: any) {
    if (!row.isEdit) {
      row.isEdit = !row.isEdit;
      row.handleEditText = "取消";
      row.isDanger = "primary";
      row.editButton = "info";
      row.handleDeleteText = "提交";
      row.handleConfirmText = "确认提交更改?";
    } else {
      row.isEdit = !row.isEdit;
      row.isDanger = "danger";
      row.editButton = "warning";
      row.handleEditText = "编辑";
      row.handleDeleteText = "删除";
      row.handleConfirmText = "确认删除脚本?";
    }
  }
  //编辑, 删除
  public async handleDeleteScript(row: any, scriptForm: any) {
    if (row.handleDeleteText === "提交") {
      const cacheForm: any = {};
      cacheForm.script_name = (document.getElementById(
        "script_name" + row.script_id
      ) as any).value;
      // 这里scene_chinese是更改后的scene id
      cacheForm.scene_chinese = (document.getElementById(
        "scene_chinese" + row.script_id
      ) as any).value;
      cacheForm.original_scene_id = (document.getElementById(
        "original_scene_id" + row.script_id
      ) as any).value;
      // todo: 场景名唯一判断
      if (cacheForm.script_name === "") {
        alert("脚本名称不能为空");
        return;
      }

      if (cacheForm.scene_chinese === "") {
        alert("场景名称不能为空");
        return;
      }

      if (!regChineseObJ.test(cacheForm.script_name)) {
        alert_re_chinese("脚本名称");
        return;
      }
      if (!regChineseObJ.test(cacheForm.scene_chinese)) {
        alert_re_chinese("场景名");
        return;
      }

      this.getProjectScenes.forEach((item: any) => {
        if (item.chinese === cacheForm.scene_chinese) {
          // alert("场景名称已存在");
          return;
        }
      });

      const commitForm: any = {
        script_name: cacheForm.script_name,
        scene:
          typeof row.scene_chinese === "number" ? row.scene_chinese : row.scene,
        old_map: row.old_map,
        old_version: row.old_version,
        project: row.project,
      };
      const sceneForm: any = {
        id:
          typeof row.scene_chinese === "number" ? row.scene_chinese : row.scene,
        original_scene_id: cacheForm.original_scene_id,
        chinese: cacheForm.scene_chinese,
        project: row.project,
      };
      await dispatchUpdateScript(store, {
        script_id: row.script_id,
        script: commitForm,
        project: row.project,
        page: this.currentPage1,
        script_name: this.search1,
        size: this.record,
      });
      await dispatchUpdateProjectScene(store, sceneForm);
      await dispatchGetScripts(store, {
        project: this.project,
        page: this.currentPage1,
        size: this.record,
        script_name: this.search1,
      });
      await this.onPaging(this.record, this.currentPage1);
    } else {
      await dispatchDeleteScript(store, {
        script_id: row.script_id,
        project: row.project,
        page: 1,
        script_name: this.search1,
        size: this.record,
      });
      // await dispatchGetScripts(store, {
      //   project: this.project,
      //   page: 1,
      //   size: this.record,
      //   script_name: this.search1,
      // });
      await this.onPaging(this.record, 1);
    }
  }

  handleDeleteScript2(row: any) {
    const commitForm: any = {
      script_name: row.script_name,
      scene: row.scene,
      old_map: row.old_map,
      old_version: row.old_map ? row.old_version : "",
      project: row.project,
    };
    const sceneForm: any = {
      id: row.scene,
      original_scene_id: row.original_scene_id,
      chinese: row.scene_chinese,
      project: row.project,
    };
    dispatchUpdateScript(store, {
      script_id: row.script_id,
      script: commitForm,
      project: row.project,
      page: this.currentPage1,
      script_name: this.search1,
      size: this.record,
    });
    dispatchUpdateProjectScene(store, sceneForm);
    dispatchGetScripts(store, {
      project: this.project,
      page: this.currentPage1,
      size: this.record,
      script_name: this.search1,
    });
  }

  //获取下拉选择选项
  public get getPerformanceSelectOptions() {
    return readPerformanceSelectOptions(store);
  }
  // 弹窗、表格 —— 游戏版本选择列表
  public get game_version_options() {
    const versions = this.getPerformanceSelectOptions.game_versions; //获取性能选择选项里的有些版本
    const game_version_select: any[] = [];
    versions.forEach((item) => {
      if (item) {
        game_version_select.push({
          label: item,
          value: item,
        });
      } else {
        game_version_select.push({
          label: "空版本",
          value: "null_version",
        });
      }
    });
    return game_version_select;
  }

  // 获取场景脚本列表
  public get getSimpleScripts() {
    const scpirt_list: any[] = this.getVisitStatistics.results;
    for (let script of scpirt_list) {
      //   account.update_date = dateConversion(account.update_time)
      const project_scene: any[] = this.getProjectScenes.filter(
        (data: any) => data?.id === script.scene
      );
      // script.scene_chinese = script.scene;
      script.scene_chinese = project_scene[0]?.chinese;
      script.original_scene_id = project_scene[0]?.original_scene_id;
      script.isEdit = false;
      script.handleEditText = "编辑";
      script.handleDeleteText = "删除";
      script.handleConfirmText = "确定删除脚本？";
      script.isDanger = "danger";
      script.editButton = "warning";
    }
    return scpirt_list;
  }

  // 脚本列表,可按场景过滤, 用于新建场景脚本时选择脚本
  public setScript(scene: any) {
    const scpirt_list: any[] = this.getVisitStatistics.results;
    return scpirt_list.filter((item) => !scene || item.scene === scene);
  }

  // 按场景去重后的脚本列表, 用于新建场景脚本时过滤脚本
  public get setScriptScene() {
    const scpirt_list: any[] = this.getVisitStatistics.results;
    const new_list: any[] = unique_json(scpirt_list, "scene");
    return new_list;
  }

  public get getProjectScenes() {
    return readProjectScenes(store);
  }
  public changeID(row: any) {
    row.original_scene_id = this.getProjectScenes.filter(
      (item: any) => item.id === row.scene_chinese
    )[0].original_scene_id;
  }

  // 关闭新建场景脚本表单时触发
  public resetAddForm(formName: any) {
    (this.$refs[formName] as any).resetFields();
    document
      .getElementsByClassName("el-upload")[0]
      .setAttribute("style", "display: inline-block");
    (this.$refs["upload"] as any).clearFiles();
    this.dialogAddFormVisible = false;
  }

  // 打开添加脚本框
  public openAddScript() {
    this.addScript = true;
    this.addScriptForm = {
      original_scene_id: "",
      chinese: "",
    };
  }
  // 关闭添加脚本框
  public closeAddScript() {
    this.addScript = false;
  }
  // 确定添加脚本
  public async addAddScript() {
    await dispatchCreateProjectScenes(store, {
      // original_scene_id: Number(this.addScriptForm.original_scene_id),
      original_scene_id: this.addScriptForm.original_scene_id,
      chinese: this.addScriptForm.chinese,
      project: this.project,
    });
    ElMessage({
      message: "场景创建成功",
      type: "success",
    });
    this.addScript = false;
  }
  public formData: any = new FormData();

  // 上传脚本文件
  public async ploadImage(param: any) {
    if (param.file === undefined) {
      document
        .getElementsByClassName("el-upload")[0]
        .setAttribute("style", "display: inline-block");
    } else {
      document
        .getElementsByClassName("el-upload")[0]
        .setAttribute("style", "display: none");
    }
    this.formData.append("file", param.file);
  }

  // 提交: 新增场景脚本
  public async submitAddForm() {
    this.loading = true;
    // 调用创建场景脚本接口
    this.formData.append("scene_id", this.filterScript);
    this.formData.append("project", this.project);
    this.formData.append("script_name", this.addForm.chinese);
    await dispatchCreateSceneScript(store, this.formData);
    this.formData = new FormData();
    document
      .getElementsByClassName("el-upload")[0]
      .setAttribute("style", "display: inline-block");
    (this.$refs["upload"] as any).clearFiles();
    // 隐藏新建表单
    this.dialogAddFormVisible = false;
    // await dispatchGetScripts(store, { project: this.project, page: this.currentPage1, size: this.record, script_name: this.addForm.chinese })
    await dispatchGetScripts(store, {
      project: this.project,
      page: this.currentPage1,
      script_name: this.search1,
      size: this.record,
    });
    this.totalNum = this.getVisitStatistics.count + 1; //分页总数
    await this.onPaging(this.record, 1);
    // await dispatchGetSimpleScripts(store, { project: this.project })
    await dispatchGetProjectScenes(store, { project: this.project });
    this.loading = false;
  }

  // 激活选择框
  public activation() {
    dispatchGetProjectScenes(store, { project: this.project });
  }
}
